import React from 'react';

export function ThesisReasoningList({ label, content, color = 'var(--t1)' }: { label: string; content: string; color?: string }) {
  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ fontSize: 9, fontFamily: 'var(--mono)', fontWeight: 700, color: 'var(--gold)', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: 3 }}>{label}</div>
      <div style={{ fontSize: 11, color, lineHeight: 1.7 }}>{content}</div>
    </div>
  );
}
